import { Drawer, Box, Typography, IconButton, ListItemSecondaryAction,Collapse, Button,Avatar} from '@mui/material'
import { useState,useEffect,useCallback } from 'react'
import MenuIcon from '@mui/icons-material/Menu'
import { getDrawerList, getDrawerListNew } from '../../common/utility/configData'
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Settings from '@mui/icons-material/Settings';
import { ChevronLeft } from '@mui/icons-material';
import { getIndexOfRoute,getIndexOfRouteNew } from '../../common/utility/helperFunc';
import { ALLOWED_ROLES_PREMIUM, ALLOWED_ROLES_ELITE, TEXT_MSGS, USER_RESOURCES_LIST, USER_ROLE_FIELDS } from '../../common/utility/constant';
import { TIERS } from '../../common/utility/roleConstants';
import {
  captureChartsMenuSelection,
  CHARTS_ACCESS_DENIED,
  CHARTS_ACCESS_PAYWALL,
} from '../../analytics/chartsTool';
import { useAxios } from '../../common/api/hooks/useAxios';
import { URL } from '../../common/api/urls';
import { useNavigate} from 'react-router-dom';
import { Snackbar, Alert} from '@mui/material';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { SNACKBAR_AUTO_HIDE_DURATION } from '../../common/utility/constant';
import DrawerContextMenu from './drawer_context_menu';
import useAuth from '../../common/hooks/useAuth';
// ============================================================
// NEW - Centralized Permission System
// See: src/common/hooks/usePermissions.js
// ============================================================
import usePermissions from '../../common/hooks/usePermissions';
import { clearLoginResults } from '../../common/utility/browserLoginCoordinator';
import { notifySameUserLoggedOut } from '../../common/api/hooks/useAxiosPrivate';
import LockIcon from '@mui/icons-material/Lock';
import RupeeIcon from '@mui/icons-material/CurrencyRupee';
import packageJson from '../../../package.json';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { DrawerNestedMenu } from './drawerNestedMenu';
import { index } from 'd3';
import { TABLE_COLORS } from '../../common/utility/table_constants';
import PersonIcon from '@mui/icons-material/Person';
import bgImageBtn from '../../assets/images/ECourse_btn_bg.png'
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LampIcon from '@mui/icons-material/FireplaceOutlined';
import StarIcon from '@mui/icons-material/InsightsOutlined';
import { UnlockIcon,Unlock,Lock } from 'lucide-react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';


const KEY_NAME_ESC = 'Escape';
const KEY_EVENT_TYPE = 'keyup';


export const APPDrawer = (props) => {
  
  const routePath=window?.location?.pathname;
  const { auth, setAuth, setPersist } = useAuth();
  // console.log("path================================>auth======================",window?.location?.pathname,window?.location,auth);
  const search=window?.location?.search;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  // const [drawerListData,setDrawerList]=useState(getDrawerList(auth))
  // ============================================================
  // OLD - Passed raw auth object (DEPRECATED)
  // Replaced by: permissions service
  // See: src/common/utility/permissionService.js
  // ============================================================
  // const [drawerListData,setDrawerList]=useState(getDrawerListNew(auth))
  
  // NEW - Use centralized permission service
  const permissions = usePermissions();
  const [drawerListData,setDrawerList]=useState(getDrawerListNew(permissions))
  // const [selectedIndex, setSelectedIndex] = useState(getIndexOfRoute(routePath,search,auth));
  const [selectedItem, setSelectedItem] = useState(getIndexOfRoute(routePath,search,auth));
  const { cancel,responseData, error, loaded, reset,executeAPI } = useAxios();
  const [showContextMenu,setShowContextMenu]=useState(false);
  const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
  const [url,setURL]=useState(undefined);
  const [collapsed, setCollapsed] =useState(true);
  // ============================================================
  // OLD - Unused planText state (DEPRECATED)
  // Replaced by: permissions.getDisplayPlanName() used directly
  // See: src/common/utility/permissionService.js
  // ============================================================
  // const [planText,setPlanText]=useState("Active Plan: NA")
  
  // ============================================================
  // NEW - Centralized Permission Service
  // See: src/common/utility/permissionService.js
  // Note: permissions is initialized above with drawerListData
  // ============================================================
  
  // ============================================================
  // OLD - Hardcoded Elite user check (DEPRECATED)
  // Replaced by: permissions.isEliteUser()
  // ============================================================
  // const isEliteUser = (auth.role.find(el => el == USER_ROLE_FIELDS.PRO) && auth.resources.find(el => el == USER_RESOURCES_LIST.TBT_FEED))
  
  // NEW - Use centralized permission check
  const isEliteUser = permissions.isEliteUser();

  const handleClick = (i) => {
    drawerListData[i].open=!drawerListData[i].open;
    setDrawerList(drawerListData);
    console.log(i,drawerListData[i])
    // setCollapsed(!collapsed);
  };

  
 
 
      
 
 const navigate = useNavigate();
 const [msgState, setMsgState] = useState({
    open: false,
    msg:"" ,
    severity:"info"
  });
  const { open, msg,severity } = msgState;

  const exitMenu=()=>{
    setShowContextMenu(false);
   }

   useEffect(()=>{
    console.log("Selected Item in drawer=",selectedItem)
     },[])

     // ============================================================
     // OLD - Unused useEffect for planText (DEPRECATED)
     // Replaced by: permissions.getDisplayPlanName() used directly
     // See: src/common/utility/permissionService.js
     // ============================================================
     // useEffect(()=>{
     //   if(props.subscriptionData)
     //     {
     //       setPlanText("Active Plan: "+props.subscriptionData.active_plan)
     //     }
     //    },[props.subscriptionData])

  // const handleListItemClick = (event, index) => {
  //   const found = auth.role.some(r=> drawerListData[index].roles.indexOf(r) >= 0)
  //   const resourceAllowed=drawerListData[index].resources==undefined?true:auth.resources?.some(r=> drawerListData[index].resources.indexOf(r) >= 0);
  //   const isProNeeded = (ALLOWED_ROLES_PREMIUM === drawerListData[index].roles);
  //   if(!found || !resourceAllowed){
  //       console.log("Not allowed for the roles",auth.role,drawerListData[index].roles, isProNeeded)
  //       //show modal
  //       if(isProNeeded){
  //         if(drawerListData[index].name=="Orderflow Charts" && auth.role.includes(USER_ROLE_FIELDS.PRO)){
  //           console.log("OF drawer inside")
  //           props.openSubscribeProModal(true,TEXT_MSGS.PREMIUM_PLUS_UPGRADE_ORDERFLOW_MSG);
  //         }
  //         else
  //           props.openSubscribeProModal();
  //       }
  //       else
  //         props.openSubscribeModal();
  //       setIsDrawerOpen(false); 
  //       return;
  //   }
  //   if(selectedIndex!==index){
  //     console.log("drawer clicked event=",event)
  //     if(event.ctrlKey ||event.metaKey){
  //       window.open( `${process.env.REACT_APP_URL}${drawerListData[index].route.slice(1)}`, '_blank', 'noreferrer');
   
  //     }
  //   else
  //   {
  //     setSelectedIndex(index);
  //     console.log("drawer pageview",window.location.pathname + window.location.search,drawerListData[index].route);
  //     props.onChange(drawerListData[index].route,drawerListData[index].component);
  //     setIsDrawerOpen(false);  
  //   }
  // }
  // };
  const handleListItemClick = (event, index,item,parentIndex=-1,sectionIndex) => {
    // ============================================================
    // OLD - Hardcoded role and resource checks (DEPRECATED)
    // Replaced by: permissions service methods
    // See: src/common/utility/permissionService.js
    // ============================================================
    // const found = auth.role.some(r=> item.items?item[index].roles.indexOf(r) >= 0:item.roles.indexOf(r) >= 0)
    // const resourceAllowed=(item.items?item[index].resources==undefined:item.resources==undefined)?true:auth.resources?.some(r=> item.resources.indexOf(r) >= 0);
    
    // NEW - Use centralized permission service with normalized roles
    const itemRoles = item.items ? item[index].roles : item.roles;
    const itemResources = item.items ? item[index].resources : item.resources;
    // Use hasAccess method which handles normalized roles and backward compatibility
    const found = itemRoles ? permissions.hasAccess(itemRoles, undefined) : true;
    const resourceAllowed = itemResources === undefined ? true : (Array.isArray(itemResources) ? permissions.hasAnyResource(itemResources) : permissions.hasResource(itemResources));
    
    const isProNeeded = (item.items?ALLOWED_ROLES_PREMIUM === item[index].roles:ALLOWED_ROLES_PREMIUM === item.roles);
    const section = drawerListData[sectionIndex ?? parentIndex];
    const parentTool = sectionIndex === undefined ? undefined : section?.data?.[parentIndex];
    const trackMenuSelection = (accessResult, openInNewTab = false) => {
      captureChartsMenuSelection({
        auth,
        item,
        parentItem: parentTool,
        section,
        menuPosition: index + 1,
        accessResult,
        openInNewTab,
      });
    };
    if(!found || !resourceAllowed){
        trackMenuSelection(props.openSubscribeModal || props.openSubscribeProModal ? CHARTS_ACCESS_PAYWALL : CHARTS_ACCESS_DENIED);
        // console.log("Not allowed for the roles",auth.role,item, isProNeeded)
        //show modal
        if(isProNeeded){
          // ============================================================
          // OLD - Hardcoded PRO check (DEPRECATED)
          // Replaced by: permissions.isPremiumUser()
          // See: src/common/utility/permissionService.js
          // ============================================================
          // if(item.name=="Orderflow Charts" && auth.role.includes(USER_ROLE_FIELDS.PRO)){
          
          // NEW - Use centralized permission service
          if(item.name=="Orderflow Charts" && permissions.isPremiumUser()){
            console.log("OF drawer inside")
            props.openSubscribeProModal(true,TEXT_MSGS.PREMIUM_PLUS_UPGRADE_ORDERFLOW_MSG);
          }
          else
            props.openSubscribeProModal();
        }
        else
          props.openSubscribeModal();
          setIsDrawerOpen(false); 
        return;
    }
    console.log("Broker item=",selectedItem,item)
    if(item.isBrokerPopup){
      props.openBrokerModal();
      setIsDrawerOpen(false); 
      return;
      
    }
    if(item.isECoursePopup){
      props.openECoursePopup();
      setIsDrawerOpen(false); 
      return;
      
    }
    // if(selectedIndex!==index){
      if(selectedItem.childIndex!=index || selectedItem.parentIndex!=parentIndex ||selectedItem.sectionIndex!=sectionIndex){
        if(event.ctrlKey ||event.metaKey){
            trackMenuSelection(undefined, true);
            window.open( `${process.env.REACT_APP_URL}${item.route.slice(1)}`, '_blank', 'noreferrer');
         }
        else
        {
          // setSelectedIndex(index);
          setSelectedItem({parentIndex:parentIndex,childIndex:index,sectionIndex:sectionIndex})
          // console.log("drawer pageview",window.location.pathname + window.location.search,item.route);
          console.log("Nested menu click 2=",index,parentIndex,selectedItem,item)
            trackMenuSelection();
            props.onChange(item.route,item.component);
          setIsDrawerOpen(false);  
        }
    }else{
      trackMenuSelection();
      window.location.reload();
    }
  };
  

  /**
 * API response handler  
 */  
  useEffect(() => {
    if(loaded){
      if(responseData!=null){
        navigate('/login', { replace: true });
      }
      else if(error!==null){
          setMsgState({open:true,msg:error?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`
        ,severity:"info"});
        
        reset();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[loaded,responseData,error,navigate]);



/**
 * API caller for logout  
 */  
 
  const logout=()=>{
    executeAPI(URL.LOGOUT,"POST",null);   
    setIsDrawerOpen(false);

    notifySameUserLoggedOut(auth?.email_id);
    clearLoginResults();

    // Clear authentication state
    setAuth({});
    setPersist(false);
    
    // Clear localStorage items
    localStorage.removeItem("accessToken");
    localStorage.removeItem("bookmark_category");
    localStorage.removeItem("bookmark_list");
    localStorage.removeItem("auto_saved_links");
    localStorage.removeItem("hasUnreadNotifications");
    localStorage.removeItem("upgrade_msg_index");
    localStorage.removeItem("persist");
    
    // Navigate to landing page
    navigate('/landing', { replace: true });
    
    // Force redirect as backup if navigation fails
    setTimeout(() => {
        window.location.replace('/landing');
    }, 100);
  }

/**
 * autoclosing of the snackbar msg bar 
 */ 
  const handleClose = (event, reason) => {
      setMsgState({...msgState,open:false});
  };
  
   //closes the context menu
  

  const handleContextMenu = (event, index, item) => {
    // console.log("context menu drawer event=",event,index,event.target.baseURI);
    event.preventDefault()
    setURL(`${process.env.REACT_APP_URL}${item.route.slice(1)}`)
    // if(item.items)
    //   setURL(`${process.env.REACT_APP_URL}${item[index].route.slice(1)}`)
    // else
    //   setURL(`${process.env.REACT_APP_URL}${drawerListData[index].route.slice(1)}`)
    // setAnchorPoint({ x: 10, y: event.pageY });
    const drawer = document.getElementById('drawer-scroll-container');
    const rect = drawer.getBoundingClientRect();
    const y = event.clientY - rect.top;
    console.log("Contextmenu event=", event)

    setAnchorPoint({ x: 10, y });
    setShowContextMenu(true);
  }
  
  const openDrawer=()=>{
    const routePath=window?.location?.pathname;
    const search=window?.location?.search;
    // console.log("UseEffect get selected index=",getIndexOfRoute(routePath,search))
    setSelectedItem(getIndexOfRoute(routePath,search,auth));
    setIsDrawerOpen(true);
  }

  useEffect(()=>{
    console.log("Drawerselecteditem=",selectedItem)
  },[selectedItem])
  
  // ============================================================
  // Update drawer list when permissions change
  // This ensures menu items update when user's auth state changes
  // ============================================================
  useEffect(() => {
    setDrawerList(getDrawerListNew(permissions));
  }, [auth?.role, auth?.resources, auth?.activePlan, permissions])
  
  // ============================================================
  // OLD - Hardcoded plan color logic (DEPRECATED)
  // Replaced by: permissions.getPlanColor()
  // See: src/common/utility/permissionService.js
  // ============================================================
  // const getPlanColorCode=()=>{
  //   let planName=props?.subscriptionData?.active_plan||undefined
  //  
  //   if(planName){
  //     if(planName=="Basic") return "#FFFFFF";
  //     if(planName.includes("Premium")) return "#23B1BA";
  //     if(planName.includes("Expert")) return "#E7B401";
  //     if(planName.includes("Elite")) return "#EC6C10";
  //     return "#FFFFFF"
  //
  //   }else{
  //     return "#FFFFFF"
  //   }
  // }
  
  // NEW - Use centralized permission service
  const getPlanColorCode = () => {
    return permissions.getPlanColor();
  }

  // ============================================================
  // OLD - Hardcoded tier checking (DEPRECATED)
  // Replaced by: permissions.getCurrentTier() comparison
  // See: src/common/utility/permissionService.js
  // ============================================================
  // const isAllowedPlan=(section)=>{
  //   let planName=props?.subscriptionData?.active_plan||undefined
  //   if(section.id=="free")
  //     return true;
  //   if(section.id=="elite"){
  //     if(planName.includes("Elite")) return true;
  //   }
  //   if(section.id=="expert"){
  //     if(planName.includes("Elite")) return true;
  //     if(planName.includes("Expert")) return true;
  //   }
  //   if(section.id=="premium"){
  //     if(planName.includes("Elite")) return true;
  //     if(planName.includes("Expert")) return true;
  //     if(planName.includes("Premium")) return true;
  //   }
  // }
  
  // NEW - Use centralized permission service with tier level comparison
  // Updated for new 3-tier system: Free → Premium → Elite
  // Expert tier removed - all Expert features merged into Premium
  const isAllowedPlan = (section) => {
    if(section.id === TIERS.FREE) return true;
    
    const currentTier = permissions.getCurrentTier();
    const tierLevels = { [TIERS.FREE]: 0, [TIERS.PREMIUM]: 1, [TIERS.ELITE]: 2 };
    
    // Map section IDs to new 3-tier system
    // Note: "expert" section no longer exists in menu, but kept for backward compatibility
    const sectionTierMap = {
      free: TIERS.FREE,
      premium: TIERS.PREMIUM,
      expert: TIERS.PREMIUM,  // Expert mapped to Premium in new 3-tier system (backward compatibility)
      elite: TIERS.ELITE
    };
    
    const requiredTier = sectionTierMap[section.id] || TIERS.PREMIUM;
    return tierLevels[currentTier] >= tierLevels[requiredTier];
  }
 
  return (
    <>
    <>
      <IconButton
        onClick={() => openDrawer()}
        size='large'
        edge='start'
        aria-label='logo'>
        <MenuIcon sx={{color:'primaryTheme.shade01',width:"32px",height:"32px"}}/>
      </IconButton>
      <Drawer
        anchor='left'
        open={isDrawerOpen}
        onClose={() =>{ 
          if(showContextMenu)
          setShowContextMenu(false);
          else{
            setShowContextMenu(false);
            setIsDrawerOpen(false)
          }
          }}>
        
        <Box id="drawer-scroll-container" p={1} width='320px' role='presentation' textAlign="left" height="100%" >
        
          <Box sx={{width:"100%",display:"flex",justifyContent:"end"}}>
            <Box sx={{width:"70%",display:"flex",justifyContent:"flex-start",textAlign:"center",alignItems:"center"}}>
              <Typography variant='titleSmall' sx={{ml:2}}>
                DASHBOARD&nbsp;&nbsp;&nbsp;<span style={{fontWeight:500,fontSize:11}}>Version {packageJson.version}</span>
              </Typography> 
            </Box>
            <Box>
            {showContextMenu?
    <DrawerContextMenu 
      xPosition={anchorPoint.x}
      yPosition={anchorPoint.y} 
      url={url}
      exitMenu={exitMenu}
      />:
    <></>}
    </Box>
    
            <Box sx={{width:"30%",display:"flex",justifyContent:"end"}}>
              <IconButton 
                  sx={{ color: 'inherit'}}
                  onClick={() => setIsDrawerOpen(false)}>
                  <ChevronLeft/>
                </IconButton>
              </Box>
            </Box>
          
            <Divider sx={{ pt: 0 }} />
            <Box sx={{ display: 'flex', flexDirection: "row", py: 1, paddingLeft: "16px", paddingRight: "8px", justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', flexDirection: "row",alignItems:'center' }}>
                {/* <PersonIcon sx={{ width: 24, mr: 1 }} /> */}
                <Avatar sx={{ bgcolor: '#C3FEF7AD', width: 35, height: 35 }}>
                  <PersonIcon sx={{ fontSize: 20, color: 'white' }} />
                </Avatar>
                {/* <Typography sx={{ ml: 1, fontSize: 16 }}>{"Active Plan:"}</Typography> */}
                <Typography sx={{ fontSize: 18, color: getPlanColorCode(), marginLeft: "8px", mt: -0.2, mr: 1, textAlign: "center", fontWeight: "bold" }} title="Active Subscription Plan">{permissions.getDisplayAccessLevel()}</Typography>
              </Box>
              {/* ============================================================
                  OLD - Hardcoded subscription data check (DEPRECATED)
                  Replaced by: permissions.shouldShowUpgradeButton()
                  See: src/common/utility/permissionService.js
                  ============================================================ */}
              {/* {props.subscriptionData && (props.subscriptionData.active_plan == "Basic" || (props.subscriptionData.subscriber == true && props.subscriptionData.active_plan != "Elite")) ? */}
              
              {/* NEW - Use centralized permission service method */}
              {/* Show upgrade button for all non-Elite users (Free and Premium) */}
              {permissions.shouldShowUpgradeButton() ?
               
                <Button variant="contained" sx={{
                  backgroundColor: "#8F2A5E", height: 35,
                  '&:hover': {
                    backgroundColor: "#F548A1"
                  }
                }}
                  onClick={() => {
                    setIsDrawerOpen(false);
                    props.openUpgradePopup()
                  }}
                >
                  Upgrade
                </Button>
                :
                <></>}
            </Box>
            {!props.isEcourseBought ?
              <Box sx={{ pb: 1, ml: 0, mt:2, textAlign: "center" }}>
                {/* <Button
                  variant="contained"
                  onClick={() => {
                    setIsDrawerOpen(false);
                    props.openECoursePopup();
                  }}
                  sx={{
                    mt: 2,
                    width: 180,
                    height: 40,
                    backgroundImage: `url(${bgImageBtn})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: 16,
                    borderRadius: 10,
                    '&:hover': {
                      // backgroundSize: '110%', // zoom on hover 
                    },
                  }}
                ></Button> */}
                <Button
                  onClick={() => {
                    setIsDrawerOpen(false);
                    props.openECoursePopup();
                  }}
                  sx={{
                    // padding: '12px 12px',
                    borderRadius: '999px',
                    background: 'linear-gradient(to bottom, #fcd669, #f4b969)',
                    boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)',
                    textTransform: 'none',
                    // display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minWidth: '220px',
                    height: 50,
                  }}
                >
                  <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#000', lineHeight: 0.8, marginTop: "10px" }}>
                    E-Course
                  </Typography>
                  <Typography variant="subtitle2" sx={{ color: '#524b4b' }}>
                    Subscribe Now
                  </Typography>
                </Button>
                {/* <Typography sx={{ color: "#e3ff59", fontWeight:700, fontSize: 16, textAlign: 'center', mt: 1, }}>SALE:&nbsp; Special Black Friday Offer</Typography> */}
                <Typography sx={{ color: "#FED994", fontSize: 14, textAlign: 'center', mt: 1, }}>Market Profile & Orderflow Trading Strategies</Typography>
                
              </Box> :
              <></>}

          
            <Divider sx={{pt:0}}/>
          <Box sx={{pt:1}}>
          {isDrawerOpen &&
           drawerListData.map((section,sectionIndex) => (
            <Box key={section.title || 'footer'} sx={{ mb: 2, ml: 2 }}>
               {section.id === TIERS.ELITE ?
                 <>
                   <Divider sx={{ mt: -1 }} />
                   {!isEliteUser ?
                     <>
                     <Box sx={{backgroundColor: '#49453c',pl:1,pr:1,borderRadius: '8px'}}>
                       <Typography sx={{ color: "#DCB146", fontSize: "24px", mt: 1 }}>Featured Tool</Typography>
                       <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 0, mb: 0.5 }}>
                         <Box sx={{ display: 'flex' }}>
                           <Typography>Orderflow</Typography>

                           <LockIcon fontSize="small" sx={{ color: "#DCB146", width: 18, marginRight: "6px", ml: 1 }} />
                         </Box>
                         <Button variant="contained" sx={{
                           backgroundColor: "#EC6C10", height: 30,mb:0,
                           '&:hover': {
                             backgroundColor: "#BA6A05"
                           }
                         }}
                           onClick={() => {
                             setIsDrawerOpen(false);
                             navigate('/subscription')
                            //  props.openUpgradePopup()
                           }}
                         >
                           Unlock
                         </Button>
                       </Box>
                       <Typography sx={{fontSize:"14px",fontStyle:'italic',mb:0,pb:1,ml:1}}>Decode live buyer-seller aggression.</Typography>
                       </Box>
                       <Divider sx={{pt:0,mb:1}}/>
                     </>
                     :
                     <></>
                   }

                 </>
                 :
                 <></>
                //  <Divider sx={{ mt: -1 }} />
               }

            {section.title && (
              <>
              <Box sx={{backgroundColor: "#25406e",pl:1,pb:0.5}}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',mt:1,mb:0 }}>
                {/* Left side: Square + Title */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                
                  <Box sx={{ width: 12, height: 12, bgcolor: `${section.color}`, mr: 1, }} />
                  <Typography sx={{ color: `${section.color}`, fontWeight: 700 }}>{section.title}</Typography>
                 
                </Box>
          
                {/* Right side: Lock Icon */}
                {section.title != "FREE ACCESS"?
                <>
                {isAllowedPlan(section)?
                <Unlock size={18} strokeWidth={2} color="#DCB146" style={{marginRight:"6px"}} />
                // <LockOpenIcon fontSize="small" sx={{color:"#DCB146",width:18,marginRight:"6px"}} />
                :
                <LockIcon fontSize="small" sx={{color:section.title=='PROFESSIONAL'?"silver":"#DCB146",width:18,marginRight:"6px"}} />
                  }</>
                  : <></>
                }
                          
              </Box>
              {section.subtittle?
                  <Typography sx={{ml:1,fontStyle: 'italic',fontSize:"14px",color: '#FED994'}}>- {section.subtittle} -</Typography>:
                  <></>
                }   
                </Box>
              </>
            )}
             {section.id=="footer" ?
                   <Divider sx={{mt:-1}}/>:
                   <></>
                  }
                {section.data.map((item,index) => (
                  <>
                  {item.items==undefined?
                  <ListItemButton
                  disableGutters
                  disableTouchRipple
                  disableRipple
                  //  divider={true}
                    key={item.name}
                    title={item.title?item.title:item.name}
                    sx={{ 
                      py: 1,
                      height: '30px !important', 
                      color: 'white', 
                      paddingRight:0,
                      ...(item.name === "Orderflow Replay" && {
                        border: '1px solid rgba(102, 126, 234, 0.4)',
                        borderRadius: '4px',
                        margin: '0 4px',
                        animation: 'pulseBorder 2.5s ease-in-out infinite',
                        '@keyframes pulseBorder': {
                          '0%, 100%': {
                            borderColor: 'rgba(102, 126, 234, 0.4)',
                            boxShadow: '0 0 0 0 rgba(102, 126, 234, 0.2)',
                          },
                          '50%': {
                            borderColor: 'rgba(102, 126, 234, 0.8)',
                            boxShadow: '0 0 8px 2px rgba(102, 126, 234, 0.3)',
                          },
                        },
                      }),
                      '&.MuiButtonBase-root': {
                  paddingTop: '2px',
                  paddingBottom: '2px',
                  paddingLeft: '8px',
                  paddingRight: '0px',
                  minHeight: '30px',
                      },
                    }}
                    // sx={item.name=="Subscription Plans"?{ py: 1, minHeight: 40, background: '#163569', color: 'white', paddingRight:0  }: { py: 1, minHeight: 40, color: 'white', paddingRight:0  }}
                    selected={selectedItem.sectionIndex==sectionIndex && selectedItem.childIndex === index && selectedItem.parentIndex==-1}
                    onContextMenu={(event)=>handleContextMenu(event,index,item)}
                    onClick={(event) => handleListItemClick(event, index,item,sectionIndex)}
                  >
                    {/* <ListItemIcon sx={{ color: 'inherit' }}>
                      {item.icon}
                    </ListItemIcon> */}
                    {/* Pulsing play icon indicator for new features */}
                    {(item.isNew || item.name === "Orderflow Replay") && (
                      <PlayArrowIcon
                        sx={{
                          fontSize: '16px',
                          color: '#667eea',
                          marginRight: '8px',
                          animation: 'pulsePlay 2s ease-in-out infinite',
                          filter: 'drop-shadow(0 0 4px rgba(102, 126, 234, 0.6))',
                          '@keyframes pulsePlay': {
                            '0%, 100%': {
                              transform: 'scale(1)',
                              opacity: 1,
                            },
                            '50%': {
                              transform: 'scale(1.2)',
                              opacity: 0.7,
                            },
                          },
                        }}
                      />
                    )}
                    <ListItemText
                      primary={item.name}
                      primaryTypographyProps={{ fontSize: item.name=="Subscription Plans"?16:14, fontWeight: item.name=="Subscription Plans"?'bold':'medium' }}
                    />
                    {/* ============================================================
                        OLD - Hardcoded role and resource checks (DEPRECATED)
                        Replaced by: permissions service methods
                        See: src/common/utility/permissionService.js
                        ============================================================ */}
                    {/* { !auth.role.some(r=> item.roles.indexOf(r) >= 0) || (item.resources!=undefined && !auth.resources?.some(r=> item.resources.indexOf(r) >= 0))? */}
                    
                    {/* NEW - Use centralized permission service with normalized roles */}
                    { !(item.roles ? permissions.hasAccess(item.roles, undefined) : true) || (item.resources!=undefined && !(Array.isArray(item.resources) ? permissions.hasAnyResource(item.resources) : permissions.hasResource(item.resources)))?
                    
                        ALLOWED_ROLES_ELITE == item.roles ?
                          <ListItemIcon sx={{ml:0,minWidth:24, color:"#DCB146"}}>
                            <LockIcon sx={{width:18}} />
                          </ListItemIcon>
                          :
                          <ListItemIcon sx={{ml:0,minWidth:24, color:"silver"}}>
                            <LockIcon sx={{width:18}} />
                          </ListItemIcon>
                        
                        : 
                          item.name=="Subscription Plans"? 
                          <ListItemIcon sx={{ml:0,minWidth:18}}>
                            {/* <LampIcon sx={{ width:20, color: "#fbfb67"}}/>&nbsp;&nbsp;
                            <StarIcon sx={{ width:20, color: "#d0fa38"}}/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
                            <RupeeIcon sx={{width:20}} />
                          </ListItemIcon>  : 
                          item.name=="ECourse Subscription"? 
                          <ListItemIcon sx={{ml:0,minWidth:18}}>
                            <RupeeIcon sx={{width:18}} />
                          </ListItemIcon> : 
                        <></>
                    }
                    </ListItemButton>
                    :<>
                    <DrawerNestedMenu item={item} onClick={handleListItemClick} onContextMenuClick={handleContextMenu} selectedItem={selectedItem} index={index} sectionIndex={sectionIndex}/>
                    {/* <ListItemButton sx={{ py: 1, minHeight: 40, color: 'white', paddingRight:0  }} onClick={()=>handleClick(index)}>
        
                    <ListItemText
                      primary={item.name}
                      primaryTypographyProps={{ fontSize: 14, fontWeight: 'medium' }}
                    />
                     {item.open ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={item.open} timeout="auto" unmountOnExit>
                      {item.items.map((nestedItem,nestedIndex) => (
                        <ListItemButton sx={{ py: 1, minHeight: 40, color: 'white', paddingRight:0  }} onClick={()=>handleClick(nestedIndex)}>
        
                        <ListItemText
                          primary={nestedItem.name}
                          primaryTypographyProps={{ fontSize: 14, fontWeight: 'medium' }}
                        />
                         
                        </ListItemButton>
                        ))}
                      </Collapse> */}


                    </>
                    }
                    
                    </>
                ))}
                    </Box>
           
                  
                ))}
                </Box>
                <Divider sx={{pt:0}}/>
                <ListItemButton
                  //  divider={true}
                    key={"logout"}
                    sx={{ py: 1, minHeight: 40, color: 'white' }}
                    onClick={logout}
                  >
                    {/* <ListItemIcon sx={{ color: 'inherit' }}>
                      <PowerSettingsNewIcon/>
                    </ListItemIcon> */}
                    <ListItemText
                      primary={"Logout"}
                      primaryTypographyProps={{ fontSize: 14, fontWeight: 'medium' }}
                    />
                    </ListItemButton>
                  
          </Box>
      </Drawer>
    

      <Snackbar onClose={handleClose} anchorOrigin={{vertical: 'top',horizontal: 'center'}}  open={open} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} >
      <Alert  severity={severity} sx={{ width:{mobile: '80%',tablet:"70%",laptop:"40%" }}}>
         {msg}
       </Alert>  
     </Snackbar>     
</>
  {/* {showContextMenu?
    <DrawerContextMenu 
      xPosition={anchorPoint.x}
      yPosition={anchorPoint.y} 
      url={url}
      exitMenu={exitMenu}
      />:
    <></>} */}
    </>
  )
}

